import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { useMediaQuery, useTheme } from "@mui/material";
import type { EventStatsNamaazRow } from "@/containers/events/types";
import { EventStatsMobileGrid } from "./EventStatsMobileGrid";

type EventDashboardNamaazStatsProps = {
  namaazCounts: EventStatsNamaazRow[];
  selectedMarkaz: string;
};

export const EventDashboardNamaazStats = ({
  namaazCounts,
  selectedMarkaz,
}: EventDashboardNamaazStatsProps) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
  const rows = namaazCounts.filter((r) => r.namaazVenue === selectedMarkaz);

  return (
    <Grid container spacing={1} sx={{ mt: { xs: 2, sm: 3 } }}>
      {isSmall ? (
        rows.map((row) => (
          <Grid key={row.name} size={12}>
            <EventStatsMobileGrid
              fields={[
                { label: "Registrations", value: row.count },
                { label: "Gents Count", value: row.gentsCount },
                { label: "Ladies Count", value: row.ladiesCount },
                { label: "Children (<10)", value: row.childrenUnder10 ?? 0 },
                { label: "Total Count", value: row.totalCount ?? 0 },
              ]}
            />
          </Grid>
        ))
      ) : (
        <Grid size={12}>
          <TableContainer
            component={Paper}
            sx={{ overflowX: "auto", WebkitOverflowScrolling: "touch", width: "100%" }}
          >
            <Table size="small" sx={{ minWidth: 720 }} aria-label="Namaaz venue stats">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Registrations</TableCell>
                  <TableCell align="center">Gents Count</TableCell>
                  <TableCell align="center">Ladies Count</TableCell>
                  <TableCell align="center">Children (&lt;10)</TableCell>
                  <TableCell align="center">Total Count</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="center">{row.count}</TableCell>
                    <TableCell align="center">{row.gentsCount}</TableCell>
                    <TableCell align="center">{row.ladiesCount}</TableCell>
                    <TableCell align="center">{row.childrenUnder10 ?? 0}</TableCell>
                    <TableCell align="center">{row.totalCount ?? 0}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}
    </Grid>
  );
};
